import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { isUndefined } from 'lodash'
import { fetchStorageById } from '../api/installation-details.api'
import { StorageModel } from 'src/Libs/storage/models'
import { CACHE_TIME } from 'src/Libs/installations/constants'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { getHttpStatusCodeFromError } from 'src/Libs/api/utils'
import { usePortalQuery } from 'src/Libs/api'

type DataReturnType = [StorageModel | null, boolean, boolean, StatusCodes | undefined]

export const useStorageById = (storageId: string | null | undefined, enabled?: boolean, log?: (value: string) => void): DataReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const queryFn = async (): Promise<StorageModel | null> => {
    const { error, hasErrors, value } = await fetchStorageById(storageId, authFetch, log)

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred when fetching storage by id')
    }

    return value
  }

  const { data, error, isLoading, isError } = usePortalQuery({
    queryKey: ['storages', storageId],
    queryFn,
    enabled: isUndefined(enabled) ? !!storageId : enabled,
    staleTime: CACHE_TIME,
    retry: false,
  })

  return [data || null, isLoading, isError, getHttpStatusCodeFromError(error)]
}
